exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Ofr8N0Hw022yc2tKpFLcN{position:absolute;bottom:10px}html[dir=ltr] .Ofr8N0Hw022yc2tKpFLcN{right:218px}html[dir=rtl] .Ofr8N0Hw022yc2tKpFLcN{left:218px}", ""]);

// exports
exports.locals = {
	"fileIcon": "Ofr8N0Hw022yc2tKpFLcN"
};